import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { useDispatch } from "react-redux";
import Thumbnail from "src/components/thumbnail";
import Text from "src/components/text";
import { getFullName } from "src/utils/utils";

import cx from "classnames";
import _ from "lodash";
import styles from "./leaderboard.module.scss";

const defaultAssetImage = "/images/defaultIcons/default_asset.jpg";

const LeaderboardReport: React.FC = () => {
  const dispatch = useDispatch();

  const { loading, leaderboards } = useSelector((state: any) => {
    const leaderboardState = _.get(state.coaching, "reports.teams.leaderboard");
    const loading = _.get(leaderboardState, "loading");
    const leaderboards = _.get(leaderboardState, "leaders") || [];

    return {
      loading: loading,
      leaderboards: leaderboards,
    };
  }, _.isEqual);

  if(_.size(leaderboards) == 0 && !loading) {
    return <></>
  }

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <h3>your team’s leaderboard</h3>
      </div>

      {loading && (
        <div className={cx(styles.grid, styles.block)}>
          {_.times(7, (index) => (
            <PlaceholderLeaderboardCard key={index} />
          ))}
        </div>
      )}

      {!loading && (
        <div className={styles.grid}>
          {leaderboards.map((item, index) => (
            <div key={index} className={styles.wrapper}>
              <LeaderboardCard item={item} rank={index + 1} />
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

interface LeaderboardCardProps {
  item: any;
  rank: number;
}

const LeaderboardCard: React.FC<LeaderboardCardProps> = ({ item, rank }) => {
  return (
    <div key={item.id} className={styles.card}>
      <div className={styles.avatar}>
        <div className={styles.number}>{rank}</div>
        <Thumbnail media={item.user.icon} defaultImage={defaultAssetImage} />
      </div>
      <div className={styles.content}>
        <Text className={styles.name} text={getFullName(item.user) || ""} lines={1} />
        <span className={styles.learnings}>
          {item.completed} learnings completed
        </span>
      </div>
    </div>
  );
};

export default LeaderboardReport;

const PlaceholderLeaderboardCard: React.FC<object> = () => {
  return (
    <div className={cx(styles.card, styles.placeholder)}>
      <div className={cx(styles.avatar, styles.block)}></div>
      <div className={styles.content}>
        <div className={cx(styles.name, styles.block)}></div>
        <div className={cx(styles.learnings, styles.block)}></div>
      </div>
    </div>
  );
};
